import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import LayoutOptions from "./components/LayoutOptions";
import Div from "@jumbo/shared/Div";
import useApp from "../../hooks/useApp";
import MainThemeOptions from "./components/MainThemeOptions";
import Stack from "@mui/material/Stack";
import HeaderOptions from "./components/HeaderOptions";
import SidebarOptions from "./components/SidebarOptions";
import FooterOptions from "./components/FooterOptions";
import LocalizationOptions from "./components/LocalizationOptions";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import ThemeModeOption from "./components/ThemeModeOptions/ThemeModeOption";
import { useSelector } from "react-redux";
import { Autocomplete, TextField, Button, Checkbox } from "@mui/material";
import cloneDeep from "lodash.clonedeep";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { dispatch } from "app/store/store";
import {
  GetGlobalAccountsFilterList,
  GetGlobalAdvertisersFilterList,
  getGlobalBannersListThunk,
  getGlobalCampaignsListThunk,
} from "app/store/slice/common-slice";
import debounce from "lodash/debounce";
import {
  updateReportingFilters,
  updateReportingFiltersFormValues,
} from "app/store/slice/report-slice";
import { CenterFocusWeakTwoTone } from "@mui/icons-material";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint } from "app/utils/constants/paths";
import {
  updateCampaignFilters,
  updateCampaignFiltersFormValues,
} from "app/store/slice/campaign-slice";
import VirtualizeAutocomplete from "app/Common/VirtualizeAutocomplete";
import {
  updatePublisherFilters,
  updatePublisherFiltersFormValues,
} from "app/store/slice/publisher-slice";
import {
  updateSegmentFilters,
  updateSegmentFiltersFormValues,
} from "app/store/slice/audience-management-slice";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const globalFilterSegmentTypesList = [
  { label: "Advertiser", value: "advertiser" },
  { label: "Publisher", value: "publisher" },
];

const SegmentFiltersCustomizer = () => {
  // const theme = useJumboTheme();
  const { customizerVisibility, setCustomizerVisibility } = useApp();
  const { globalAccountsList, authUserData } = useSelector(
    (state) => state.CommonReducer
  );

  const { segmentFilterFormValues } = useSelector(
    (state) => state.AudienceManagementReducer
  );

  console.log("Segment Filters:", segmentFilterFormValues);

  const [formValues, setFormValues] = useState({
    accounts: {
      source: globalAccountsList, //globalFilterAccountsList
      value: segmentFilterFormValues.accounts,
    },
    segmenttypes: {
      source: globalFilterSegmentTypesList, //globalFilterAdvertisersList,
      value: segmentFilterFormValues.segmenttypes,
    },
  });

  //   useEffect(() => {
  //     filterChildDropDown(
  //       "accounts",
  //       "publishers",
  //       "account_id",
  //       globalPublishersList
  //     );
  //   }, [formValues.accounts.value]);

  const multiSelectChangeHandler = (name, value) => {
    let inputName = name;
    let inputValue = value != undefined && value != null ? value : "";
    setFormValues((prevState) => ({
      ...prevState,
      [inputName]: {
        ...prevState[inputName],
        value: inputValue,
      },
    }));
    dispatch(
      updateSegmentFiltersFormValues({ type: inputName, data: inputValue })
    );
  };

  //   const filterChildDropDown = (
  //     parentId,
  //     childId,
  //     childParentKey,
  //     childMasterData
  //   ) => {
  //     let selParentValuesArr = Array.isArray(formValues[parentId].value)
  //       ? formValues[parentId].value
  //       : [formValues[parentId].value];
  //     let selchildValuesArr = cloneDeep(formValues[childId].value);

  //     //console.log("Child Parent Key:", childParentKey);
  //     //console.log("Child Parent Values:", selParentValuesArr);

  //     if (selParentValuesArr <= 0) {
  //       selParentValuesArr = Array.isArray(formValues[parentId].source)
  //         ? formValues[parentId].source
  //         : [formValues[parentId].source];
  //     }

  //     let modChildList = childMasterData;
  //     //if (selParentValuesArr.length > 0) {
  //     modChildList = childMasterData.filter((item, index) => {
  //       return selParentValuesArr.some((v) => v.value == item[childParentKey]);
  //     });
  //     // }

  //     let selChildList = modChildList.filter((item, index) => {
  //       return selchildValuesArr.some((v) => v.value == item.value);
  //     });

  //     let finalObj = {};
  //     finalObj = {
  //       ...formValues,
  //       [childId]: {
  //         ...formValues[childId],
  //         source: modChildList,
  //         value: selChildList,
  //       },
  //     };
  //     setFormValues(finalObj);
  //   };

  const applyFilter = async (isClose = true) => {
    let accountsArr = [];
    let segmenttypesArr = [];

    segmentFilterFormValues.accounts.map((accInfo) => {
      accountsArr.push(accInfo.value);
    });
    segmentFilterFormValues.segmenttypes.map((advInfo) => {
      segmenttypesArr.push(advInfo.value);
    });

    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      accountsArr =
        accountsArr.length > 0
          ? accountsArr
          : globalAccountsList.map((accInfo) => {
              return accInfo.value;
            });
    }

    let selFilters = {
      accounts: accountsArr,
      segmenttypes: segmenttypesArr,
    };

    dispatch(updateSegmentFilters(selFilters));

    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  const clearFilter = (isClose = true) => {
    let finalObj = cloneDeep(formValues);
    finalObj.accounts.value = [];
    finalObj.segmenttypes.value = [];

    setFormValues(finalObj);

    dispatch(updateSegmentFiltersFormValues({ action: "delete" }));

    let accountsArr = [];
    let segmenttypesArr = [];

    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      accountsArr =
        accountsArr.length > 0
          ? accountsArr
          : globalAccountsList.map((accInfo) => {
              return accInfo.value;
            });
    }
    let selFilters = {
      accounts: accountsArr,
      segmenttypes: segmenttypesArr,
    };
    dispatch(updateSegmentFilters(selFilters));
    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  //To Apply Filters
  useEffect(() => {
    applyFilter();
  }, []);

  return (
    <Drawer
      anchor={"right"}
      open={customizerVisibility}
      onClose={() => setCustomizerVisibility(false)}
      sx={{
        zIndex: 1205,

        "& .MuiDrawer-paper": {
          width: 336,
        },
      }}
    >
      <Div
        sx={{
          display: "flex",
          minWidth: 0,
          position: "relative",
          zIndex: 2,
          p: (theme) => theme.spacing(1.5, 3),
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: 25,
        }}
      >
        <Typography variant={"h3"} mb={0} sx={{ fontSize: "14px" }}>
          Filters
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setCustomizerVisibility(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Div>
      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Stack sx={{ px: 3, pt: 2 }}>
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1) && (
            <VirtualizeAutocomplete
              id="Account"
              label="Accounts"
              placeholder="Search Accounts"
              list={globalAccountsList}
              selectedValues={
                formValues.accounts.value != "" ? formValues.accounts.value : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="accounts"
            />
          )}

          <Autocomplete
            id="Segmenttype"
            multiple
            disableClearable
            options={globalFilterSegmentTypesList}
            disableCloseOnSelect
            getOptionLabel={(option) => option.label}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label}
              </li>
            )}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                id="Segmenttype"
                name="Segmenttype"
                label="Segment Types"
                variant="standard"
                placeholder="Select Segment Types"
                fullWidth
                sx={{ mb: 1 }}
                autoComplete="off"
              />
            )}
            value={
              formValues.segmenttypes.value != ""
                ? formValues.segmenttypes.value
                : []
            }
            // onInputChange={(event, newInputValue) => {
            //   setBannerInputValue(newInputValue);
            //   getBannersList(newInputValue);
            // }}
            // inputValue={bannerInputValue}
            onChange={(e, newValue) => {
              multiSelectChangeHandler("segmenttypes", newValue);
            }}
            // onBlur={(e, newValue) => {
            //   setBannerInputValue("");
            // }}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ px: 3, pt: 2 }}
          spacing={2}
        >
          <Button variant="contained" onClick={applyFilter}>
            Apply
          </Button>
          <Button variant="contained" color="error" onClick={clearFilter}>
            Clear
          </Button>
        </Stack>
      </JumboScrollbar>
    </Drawer>
  );
};

export default SegmentFiltersCustomizer;
